import styled from 'styled-components';

export const MobileHistoryEmptyStyled = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    padding: 24px 16px 16px;
    margin: 0 16px;
    background: var(--color-neutral-20);
    border-radius: 16px;
    color: var(--color-white-95);
    
    h4 {
        font-weight: 700;
        font-size: 16px;
        margin-top: 16px;
    }
    
    p {
        font-size: 14px;
        line-height: 24px;
        margin: 8px 0 0;
    }
    
    button {
        margin-top: 40px;
    }
`;

export const MobileHistoryEmptyIconWrapperStyled = styled.div`
    font-size: 38px;
    display: flex;
    justify-content: center;
`;
